import { useEffect } from "react";
import { Routes, Route, useNavigationType, useLocation } from "react-router-dom";
import Landing from "./pages/Landing";

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "Doubleyes";
    let metaDescription = "Doubleyes";

    switch (pathname) {
      case "/":
        title = "Doubleyes";
        metaDescription = "Doubleyes";
        break;
        
      default:
        title = "Doubleyes";
        metaDescription = "Doubleyes";
        break;
    }

    document.title = title;

    const metaDescriptionTag = document.querySelector('head > meta[name="description"]');
    if (metaDescriptionTag) {
      metaDescriptionTag.content = metaDescription;
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
    </Routes>
  );
}

export default App;